// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (min-width: 767px) {\n.jobs-scope-select[data-v-1cb01ebe] {\n    width: 150px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
